import { Steps } from "primereact/steps";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { CheckUserExistByMobile } from "../../services/AccountService";
import { GetInvitationByInvitationId } from "../../services/InvitationService";
import { Button } from "@mui/material";

const InvitationNotFound = () => {
	const navigate = useNavigate();

	return (
		<>
			<div className="container mt-5 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12   ">
				<p className="w-100 " style={{ textAlign: "center" }}>
					دعوتنامه مورد نظر شما یافت نشد
				</p>
				<div className="w-100 " style={{ textAlign: "center" }}>
					<Button
						onClick={() => {
							navigate("/");
						}}
						variant="contained"
						color="primary">
						{" "}
						بازگشت به صفحه اصلی{" "}
					</Button>
				</div>
			</div>
		</>
	);
};
export default InvitationNotFound;
